/*
	MUTATIONS
*/
//------------------------------------------------------------
// ADD WINDOW
//------------------------------------------------------------

const ADD_WINDOW = (state, target) => {
	state.openWindows.push(target);
}

//------------------------------------------------------------
// REMOVE WINDOW
//------------------------------------------------------------

const REMOVE_WINDOW = (state, target) => {
	const index = state.openWindows.indexOf(target);
	state.openWindows.splice(index, 1);

	// overwrite a closed window with the same path
	state.closedWindows.forEach((item, index, arr) => {
		if (item.path == target.path)
			arr.splice(index, 1);
	});
	// store it
	state.closedWindows.push(target);
}

//------------------------------------------------------------
// MAXIMIZE WINDOW
//------------------------------------------------------------

const MAXIMIZE_WINDOW = (state, target) => {
	target.windowData.maximized = !target.windowData.maximized;
}

//------------------------------------------------------------
// MINIMIZE WINDOWS
//------------------------------------------------------------

const MINIMIZE_WINDOWS = (state) => {
	state.openWindows.forEach(item => item.windowData.minimized = true);
}

//------------------------------------------------------------
// MINIMIZE WINDOW
//------------------------------------------------------------

const MINIMIZE_WINDOW = (state, payload) => {
	payload.target.windowData.minimized =
		typeof payload.bool !== 'undefined' ? payload.bool : !payload.target.windowData.minimized;
}

//------------------------------------------------------------
// CLEAR WINDOWS
//------------------------------------------------------------

const CLEAR_WINDOWS = (state) => {
	state.openWindows = [];
}

//------------------------------------------------------------
// SELECT WINDOW
//------------------------------------------------------------

const SELECT_WINDOW = (state, payload) => {
	const target = payload.target.windowData;
	target.active = true;
	target.z = payload.newZ;
}

//------------------------------------------------------------
// DESELECT WINDOWS
//------------------------------------------------------------

const DESELECT_WINDOWS = (state) => {
	state.openWindows.forEach(item => item.windowData.active = false);
}

//------------------------------------------------------------
// UPDATE WINDOW
//------------------------------------------------------------

const UPDATE_WINDOW = (state, payload) => {
	const target = payload.target.windowData;
	target.x = payload.x;
	target.y = payload.y;

	// don't update size if null (from dragging alone)
	if (payload.width) target.width = payload.width;
	if (payload.height) target.height = payload.height;
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	ADD_WINDOW,
	CLEAR_WINDOWS,
	DESELECT_WINDOWS,
	MAXIMIZE_WINDOW,
	MINIMIZE_WINDOW,
	MINIMIZE_WINDOWS,
	REMOVE_WINDOW,
	SELECT_WINDOW,
	UPDATE_WINDOW,
}

//===========================================
//
//===========================================